import {PopupDropdown} from '@wandb/weave/common/components/PopupDropdown';
import React, {memo} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Checkbox} from 'semantic-ui-react';

import {Counts as RunCounts} from '../util/runTypes';
import {MultiStateCheckbox} from './MultiStateCheckbox';
import {useRunSelectorAnalyticsLocation} from './RunSelector/RunSelectorAnalyticsLocationContext';

interface RunSelectAllProps {
  runCounts?: RunCounts;
  allCheckedState: 'unchecked' | 'checked' | 'partial' | 'unknown';
  onlyShowSelected?: boolean;
  setOnlyShowSelected?(newSetting: boolean): void;
  selectAllVisible(): void; // copies visualized runs to temp selections
  onSelectAll(): void;
  onSelectNone(): void;
}

const RunSelectAllComp: React.FC<RunSelectAllProps> = ({
  allCheckedState,
  onSelectAll,
  onSelectNone,
  runCounts,
  onlyShowSelected,
  setOnlyShowSelected,
  selectAllVisible,
}) => {
  const analyticsLocation = useRunSelectorAnalyticsLocation();
  const selectedCount =
    runCounts && runCounts.runs && runCounts.selected && runCounts.selected;
  const dropdownOptions = [
    {
      key: 'selectall',
      content: 'Visualize all',
      onClick: onSelectAll,
    },
    {
      key: 'selectnone',
      content: 'Visualize none',
      onClick: onSelectNone,
    },
    {
      key: 'selectallvisible',
      content: 'Select all visible runs',
      onClick: selectAllVisible,
    },
    {
      key: 'onlyshowselected',
      onClick: () => {
        if (setOnlyShowSelected) {
          setOnlyShowSelected(!onlyShowSelected);
        }
      },
      content: (
        <Checkbox
          toggle
          checked={onlyShowSelected}
          label={`Only show visualized${
            selectedCount ? ` (${selectedCount})` : ''
          }`}
        />
      ),
    },
  ];
  return (
    <PopupDropdown
      options={dropdownOptions}
      className="popup-dropdown--selectall"
      trigger={
        <MultiStateCheckbox
          data-test="all-runs-visibility-checkbox"
          aria-label="Visibility options"
          onClick={() =>
            window.analytics?.track('Visibility dropdown clicked', {
              location: analyticsLocation,
            })
          }
          checked={allCheckedState}
          theme="visibility"
        />
      }
    />
  );
};

export const RunSelectAll = memo(RunSelectAllComp);
